import { BaseDataService } from './BaseDataService';
import { ScoreCard } from '../../models';
import { NotificationService } from '../../services';

export class ScoreCardDataService extends BaseDataService<ScoreCard> {
    constructor(notificationService: NotificationService) {
        super('Score Card', 'Score Cards', notificationService);
    }

    public copy (scoreCardId: number) {
        const endpoint = `${this.endpointRoot}/copy/${scoreCardId}`;
        const init = this.buildRequestInit('POST');

        return fetch(endpoint, init).then((response) => {
            if (response.ok) {
                return response.json();
            }
            throw new Error('Could not copy Score Card');
        });
    }

    public getAllByOrganization (organizationId: number) {
        const endpoint = `${this.endpointRoot}/byOrganization/${organizationId}`;
        const init = this.buildRequestInit('GET');

        return fetch(endpoint, init).then((response) => {
            if (response.ok) {
                return response.json();
            }
            throw new Error('Could not retrieve Score Cards');
        });
    }
}


// WEBPACK FOOTER //
// ./src/services/api/ScoreCardDataService.tsx